import { render } from "./setup.vue?vue&type=template&id=61389122"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/messages-app V2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__